import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [

    {
      field: 'name',
      type: 'input',
      label: '客户昵称',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      field: 'unionid',
      type: 'input',
      label: '客户UnionId',
      clearable: true,
      placeholder: '请输入客户UnionId'
    },
    {
      field: 'corpName',
      type: 'select',
      label: '主体名称',
      filterable: true,
      clearable: true,
      placeholder: '请选择主体名称'
    },
    {
      field: 'empId',
      type: 'input',
      label: '业务员账号',
      clearable: true,
      placeholder: '请输入业务员账号'
    },
    {
      field: 'groupName',
      type: 'select',
      label: '所属组别',
      filterable: true,
      clearable: true,
      placeholder: '请选择组别'
    },
    {
      field: 'succAmount',
      type: 'select',
      label: '成交金额',
      clearable: true,
      placeholder: '重复次数',
      options: [
        {title: '不限', value: ''},
        {title: '≥ 5万', value: 50000},
        {title: '≥ 10万', value: 100000}
      ]
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '渠道第三方',
      filterable: true,
      clearable: true,
      placeholder: '请选择渠道第三方'
    },
    {
      field: 'sourceLabel',
      type: 'select',
      label: '来源渠道',
      filterable: true,
      clearable: true,
      placeholder: '请选择所属渠道'
    },
    {
      field: 'createdAt',
      type: 'datepicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
      }
    },
    {
      field: 'succTime',
      type: 'datepicker',
      label: '成交时间',
      otherOptions: {
        startPlaceholder: '开始时间',
        endPlaceholder: '结束时间',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
      }
    }
  ]
}
